<script>
    import { SelectedSnippetsStore } from "$/stores/SelectedSnippetsStore";
    import { fly } from "svelte/transition";

    // NOTE: every action should have let from BottomPopUpModalAction
    export let actions;
    export let isExtension = false;
    export let initialText = "";
    export let confirmationTexts = [];

    let isLoading;
    let showConfirmationPopup = false;
    let showActionIndex = 0;

    async function showConfirmationAction(i) {
        showActionIndex = i;
        showConfirmationPopup = true;
    }

    async function handleAction(action) {
        isLoading = true;
        await action();
        isLoading = false;
    }

    function handleClickAction(action) {
        return function () {
            handleAction(action);
        };
    }

    async function handleCancel(cancelAction) {
        await cancelAction();
    }

    function handleCancelAction(cancelAction) {
        return function () {
            handleCancel(cancelAction);
        };
    }
</script>

<div
    in:fly={{ y: 200, duration: 1000 }}
    class="cw-popup"
    class:cw-popup--ext={isExtension}
>
    <div class="cw-popup--modal">
        {#if !showConfirmationPopup}
            <div class="cw-popup--modal__action-bg"></div>
            <div class="cw-popup--modal-initial-section">
                <span>{@html initialText}</span>
                {#each actions as action, i}
                    <button
                        class="cw-popup--modal__action"
                        class:cw-action-pink={action.color === "pink"}
                        class:cw-action-hover-pink={action.color === "pink"}
                        on:click={() => {
                            showConfirmationAction(i);
                        }}
                    >
                        {action.name}
                    </button>
                {/each}
            </div>
        {/if}
        {#each actions as action, i}
            {#if showConfirmationPopup && showActionIndex === i}
                <div
                    class="cw-popup--modal__action-bg"
                    class:cw-popup--bg-pink={actions[showActionIndex].color ===
                        "pink"}
                ></div>
                {#if isLoading}
                    <div class="cw-popup--modal-section">
                        <svg
                            class="cw-popup--modal__loading--icon"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                            />
                        </svg>
                        <span class="cw-popup--modal__loading--text"
                            >{actions[showActionIndex].loadingText}</span
                        >
                    </div>
                {:else}
                    <div class="cw-popup--modal-section">
                        <span class="cw-popup--modal__text">
                            {@html confirmationTexts[showActionIndex]}
                        </span>
                    </div>
                    <div class="cw-popup--modal-section__buttons">
                        <button
                            class="cw-popup--modal__action--cancel"
                            class:cw-action-hover-pink={actions[showActionIndex]
                                .color === "pink"}
                            on:click={handleCancelAction(
                                actions[showActionIndex].cancel,
                            )}
                        >
                            Cancel
                        </button>
                        <button
                            class="cw-popup--modal__action"
                            class:cw-action-pink={actions[showActionIndex]
                                .color === "pink"}
                            class:cw-action-hover-pink={actions[showActionIndex]
                                .color === "pink"}
                            on:click={handleClickAction(
                                actions[showActionIndex].action,
                            )}
                        >
                            {actions[showActionIndex].name}
                        </button>
                    </div>
                {/if}
            {/if}
        {/each}
    </div>
</div>

<style>
    .cw-popup {
        @apply reset fixed bottom-0 z-50 flex w-full flex-row flex-wrap items-center justify-center gap-x-4 gap-y-0 overflow-hidden bg-transparent md:bottom-4 md:flex md:bg-transparent !important;
    }

    .cw-popup--ext {
        @apply bottom-14 overflow-hidden !important;
    }

    .cw-popup--modal {
        @apply reset mx-4 my-2 flex w-full max-w-md flex-row items-center justify-between gap-1 overflow-hidden rounded-full px-4 py-2 font-light text-black shadow-[0px_0px_10px_-2px_#A0AEC0] transition-all !important;
    }

    .cw-popup--modal-initial-section {
        @apply reset flex w-full flex-row justify-between !important;
    }

    .cw-popup--modal-initial-section span {
        @apply reset self-center text-sm font-normal text-black !important;
    }

    .cw-popup--modal-section {
        @apply reset flex flex-row items-center gap-1 !important;
    }

    .cw-popup--modal-section__buttons {
        @apply reset flex flex-row items-center !important;
    }

    .cw-popup--modal__action-bg {
        @apply reset absolute left-0 top-0 z-[-1] h-full w-full bg-white !important;
    }

    .cw-popup--modal__loading--icon {
        @apply reset mr-1 h-5 w-5 animate-spin text-black !important;
    }

    .cw-popup--modal__loading--text {
        @apply reset text-sm font-normal text-black !important;
    }

    .cw-popup--modal__action {
        @apply reset rounded-sm border-none bg-transparent px-2 py-1 text-xs font-normal text-black no-underline hover:cursor-pointer !important;
    }

    .cw-popup--modal__action--cancel {
        @apply reset rounded-sm border-none bg-transparent px-2 py-1 text-xs font-normal text-black no-underline hover:cursor-pointer !important;
    }

    .cw-popup--modal__icon {
        @apply reset mr-1 h-5 w-5 text-black !important;
    }

    .cw-popup--modal__text {
        @apply reset text-sm font-normal text-black !important;
    }

    .white-shadow {
        @apply reset shadow-[0px_-20px_20px_0px_rgba(255,255,255,1)] !important;
    }

    .cw-popup--bg-pink {
        @apply bg-pink-100 !important;
    }

    .cw-action-pink {
        @apply font-bold text-pink-500 !important;
    }

    .cw-action-hover-pink {
        @apply hover:bg-pink-200 !important;
    }
</style>
